import { SessionHelper } from "./sessionHelper";

// Extract the current query params from the url
// to use when a new route is set
export const extractUrlFilterParams = (
  currentUrl: URL = new URL(window.location.href)
) => {
  const searchParams = new URLSearchParams(currentUrl.search);
  const filter = searchParams.get("filter") || "popular";
  const period = searchParams.get("period");

  return {
    filter,
    period,
    queryString:
      filter === "all"
        ? `filter=${filter}&period=${period}`
        : `filter=${filter}`,
  };
};

// When clicking on main logo
// - if public view, go to /
// - if not logged in, go to /
// - if logged in euro, go to /events
// - if logged in asian, go to /asian/events
export const getMainLogoPath = (
  isPublicView: boolean,
  pathname: string
): string => {
  if (isPublicView || !SessionHelper.isAuthenticated()) {
    return "/";
  }

  return pathname.includes("/asian/") ? "/asian/events/" : "/events/";
};
